import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import * as fas from '@awesome.me/kit-113d5f5ec2/icons/classic/solid';
import * as fal from '@awesome.me/kit-113d5f5ec2/icons/classic/light';
import * as far from '@awesome.me/kit-113d5f5ec2/icons/classic/regular';
import * as fad from '@awesome.me/kit-113d5f5ec2/icons/duotone/solid';
import * as fadr from '@awesome.me/kit-113d5f5ec2/icons/duotone/regular';

library.add(fas, fal, fad, far, fadr);

// Register component
Vue.component('fa', FontAwesomeIcon);